import { FC, useMemo } from "react";
import { getTeamColors } from "components/colors";
import { TwoSideStat } from "../../../components/common/TwoSideStat";

type ServePointsWonProps = {
  status: any;
  statusText: string;
};

export const ServePointsWon: FC<ServePointsWonProps> = ({
  statusText,
  status,
}) => {
  const { home: homeColor, away: awayColor } = getTeamColors(status);

  const { homeRaw, awayRaw } = useMemo(() => {
    const seg = statusText
      ?.split("|")
      .map((s) => s.trim())
      .find((p) => p.startsWith("Points Won on Serve="));

    const raw = seg?.split("=")[1] ?? "";
    const [h, a] = raw.split(":").map((x) => (x ?? "").trim());

    const withPercent = (v: string) =>
      v ? (v.endsWith("%") ? v : `${v}%`) : "0%";

    return {
      homeRaw: withPercent(h),
      awayRaw: withPercent(a),
    };
  }, [statusText]);

  return (
    <TwoSideStat
      homeColor={homeColor}
      awayColor={awayColor}
      leftValue={homeRaw}
      rightValue={awayRaw}
      bottomLabel="SERVE POINTS WON"
    />
  );
};
